/* eslint-disable */

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { motion, AnimatePresence } from "framer-motion";

const T = {
  ink:        "#0F0F0F",
  jade:       "#0F6E56",
  jadeMid:    "#1D9E75",
  saffron:    "#D97706",
  slate:      "#6B7280",
  border:     "rgba(0,0,0,0.1)",
  white:      "#FFFFFF",
};

// ─── Option A: Redirect approach (recommended) ────────────────
// Uncomment this export and comment out the StandaloneLogin export below.
//
// export default function Login() {
//   const navigate = useNavigate();
//   const { currentUser } = useAuth();
//   useEffect(() => {
//     if (currentUser) { navigate("/welcome"); return; }
//     navigate("/", { replace: true });
//   }, []);
//   return null;
// }

// ─── Option B: Standalone full-page login (default) ───────────
export default function Login() {
  const { login } = useAuth() as any;
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [error, setError]       = useState("");
  const [loading, setLoading]   = useState(false);

  useEffect(() => {
    if (currentUser) navigate("/welcome");
  }, [currentUser]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/welcome");
    } catch {
      setError("Invalid email or password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const inputStyle: React.CSSProperties = {
    width: "100%", boxSizing: "border-box",
    padding: "13px 15px", borderRadius: 10,
    border: `1.5px solid ${T.border}`,
    fontSize: 15, color: T.ink, outline: "none",
    background: "#FAFAFA", fontFamily: "inherit",
    transition: "border-color 0.15s",
  };

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(160deg,#FAFAF8 0%,#F0FBF6 50%,#FFFBEB 100%)",
      display: "flex", alignItems: "center", justifyContent: "center",
      padding: 24, fontFamily: "'Inter',system-ui,sans-serif",
      position: "relative", overflow: "hidden",
    }}>
      {/* Background orbs */}
      <div style={{ position:"absolute", width:340, height:340, borderRadius:"50%", top:"5%", right:"5%",
        background:"radial-gradient(circle,rgba(29,158,117,0.08) 0%,transparent 70%)" }} />
      <div style={{ position:"absolute", width:260, height:260, borderRadius:"50%", bottom:"8%", left:"5%",
        background:"radial-gradient(circle,rgba(217,119,6,0.07) 0%,transparent 70%)" }} />

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.55, ease: [0.16, 1, 0.3, 1] }}
        style={{
          width: "100%", maxWidth: 400,
          background: T.white, borderRadius: 20,
          padding: "34px 32px 28px",
          boxShadow: "0 4px 40px rgba(0,0,0,0.08)",
          border: `1px solid rgba(0,0,0,0.06)`,
          position: "relative",
        }}
      >
        <p style={{
          fontFamily: "'Georgia','Times New Roman',serif",
          fontSize: 22, fontWeight: 700, color: T.ink, margin: "0 0 4px",
        }}>MySatsang</p>
        <p style={{ fontSize: 14, color: T.slate, margin: "0 0 26px" }}>
          Sign in to your account
        </p>

        <AnimatePresence>
          {error && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              style={{
                background: "#FEF2F2", border: "1px solid #FECACA",
                borderRadius: 8, padding: "10px 14px",
                fontSize: 13, color: "#B91C1C", marginBottom: 16,
                overflow: "hidden",
              }}
            >
              {error}
            </motion.div>
          )}
        </AnimatePresence>

        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <input
            type="email" placeholder="Email address"
            value={email} onChange={e => setEmail(e.target.value)}
            required style={inputStyle}
            onFocus={e => (e.target.style.borderColor = T.jadeMid)}
            onBlur={e => (e.target.style.borderColor = T.border)}
          />
          <input
            type="password" placeholder="Password"
            value={password} onChange={e => setPassword(e.target.value)}
            required style={inputStyle}
            onFocus={e => (e.target.style.borderColor = T.jadeMid)}
            onBlur={e => (e.target.style.borderColor = T.border)}
          />

          <button
            type="submit" disabled={loading}
            style={{
              marginTop: 6,
              background: loading ? "#6B7280" : T.ink,
              color: T.white, border: "none", borderRadius: 10,
              padding: "13px 0", fontSize: 15, fontWeight: 600,
              cursor: loading ? "not-allowed" : "pointer",
              fontFamily: "inherit", letterSpacing: "0.01em",
              transition: "background 0.15s",
            }}
          >
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <p style={{
          fontSize: 14, color: T.slate, textAlign: "center",
          marginTop: 20, margin: "20px 0 0",
        }}>
          Don't have an account?{" "}
          <span
            onClick={() => navigate("/signup")}
            style={{ color: T.jade, fontWeight: 600, cursor: "pointer" }}
          >
            Create one
          </span>
        </p>
      </motion.div>
    </div>
  );
}